import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  // faqData = null,
  constituencyListData = null,
}) {
  const isMobileDevice = useIsMobile();
  let metaData = {
    title: `Assam Vidhan Sabha Election 2026 Exit Polls: पहले अनुमान और सीट-वार संभावना - NewsTak`,
    description: `Assam Assembly Election 2026 Exit Polls: जानें विधानसभा चुनाव 2026 मे किस गठबंधन को कितनी सीट मिल सकती है, प्रमुख सीटों की संभावना और सीट-वार अनुमान। ताज़ा अपडेट और विश्लेषण सिर्फ NewsTak.in पर.`,
    keywords: `Assam exit poll 2026, Assam Assembly Election 2026 exit polls, असम विधानसभा चुनाव 2026 एग्जिट पोल, Assam election 2026 seat prediction, असम चुनाव 2026 अनुमान, Assam Vidhan Sabha Chunav exit poll, असम चुनाव रिजल्ट अनुमान, Assam election analysis 2026`,
  };
const exitPollData = [
  {
    name: "BJP+",
    seats: "75-85",
    width: "63.49%",
    color: "#F57E20",
    logo: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/bjp.jpg",
  },
  {
    name: "CONG+",
    seats: "40-50",
    width: "35.71%",
    color: "#4B91CF",
    logo: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/inc.jpg",
  },
  {
    name: "OTH",
    seats: "1-4",
    width: "1.98%",
    color: "#575757",
    logo: "https://akm-img-a-in.tosshub.com/sites/electiontak/images/counting-day/partylogo-118x118/others.jpg",
  },
];
  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`${electionCategory}/exit-poll`}
         
          isMobileDevice={isMobileDevice}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="assam_election"
          stateName={"Assam"} //"Delhi"
          stateHindi={"असम"}
          metaData={metaData}
          constituencyListData={constituencyListData}
          exitPollData={exitPollData}
          halfwayMark={"64"}
         />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/exit-poll")[0];

  let electionCategory = url.split("/elections/")[1];
 
  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

 let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.assam_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
       ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 86400);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory: electionCategory,
        // faqData,
        constituencyListData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
